import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import ProductPage from "./pages/productPage";
import CartPage from "./pages/cartPage";
import AccountPage from "./pages/accountPage";
import AddressPage from "./pages/addressPage";
import WishlistPage from "./pages/wishlistPage";
import MyOrderPage from "./pages/myOrderPage";
import MobileSidebar from "./pages/mobileSidebar";
import AllProductPage from "./pages/allProductPage";
import OrderPlacePage from "./pages/orderPlacePage";
import ScrollToTop from "./components/common/scrollToTop";
import SignINPage from "./pages/signInPage";
import UserInfo from "./pages/userInfo";
import AllOrderPage from "./pages/allOrderPage";

function App() {
  const [token, setToken] = useState();

  useEffect(() => {
    const token = localStorage.getItem("STITCHD_ID");
    if (token) {
      setToken(token);
    }
  }, [token]);

  return (
    <div style={{ fontFamily: "Poppins, sans-serif" }}>
      <Router>
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/product/:id" element={<ProductPage />} />
            <Route path="/cart" element={token ? <CartPage/> : <SignINPage />} />
            <Route path="/account" element={token ? <AccountPage/> : <SignINPage />} />
            <Route path="/address" element={<AddressPage />} />
            <Route path="/wishlist" element={token ? <WishlistPage/> : <SignINPage />} />
            <Route path="/orders" element={<MyOrderPage />} />
            <Route path="/allorders" element={<AllOrderPage />} />
            <Route path="/sidebar" element={<MobileSidebar />} />
            <Route path="/allproduct/:category" element={<AllProductPage />} />
            <Route path="/orderplaced" element={<OrderPlacePage />} />
            <Route path="/signin" element={<SignINPage />} />
            <Route path="/userinfo" element={<UserInfo />} />
          </Routes>
        </ScrollToTop>
      </Router>
    </div>
  );
}

export default App;
